<style lang="scss" scoped>
    .breadcumb{
        text-transform: uppercase;
        margin-left: 5px;
        margin: 0;
        padding: 0;
        height: 14px;

        .el-breadcrumb__item{
            font-size: 1rem !important;
        }

        @media (max-width:360px) {
            height: auto;
        }
    }
</style>
<template>
    <div class="d-inline-block breadcumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :key="myPath.name" v-for="myPath in pathsTobuild.filter(t => t.route)" :to="{ path: myPath.route }">{{myPath.name}}</el-breadcrumb-item>
            <el-breadcrumb-item :key="myPath.name" v-for="myPath in pathsTobuild.filter(t => !t.route)">{{myPath.name}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>

export default{
    props: ['paths'],
    name: 'breadcumbs',
    data(){
        return {
            pathsTobuild: [],
        }
    },
    components: {
    },
    created(){
        this.pathsTobuild = this.paths;
    }
}
</script>
